import { DATASET_ID_CHANGE, TASK_ID_CHANGE, 
  INIT_DATASET_LIST, CLEAR_ID_INFO, 
  INIT_DATA, API_ID_CHANGE, API_ID_LIST_CHANGE, 
  INIT_EXPLORE_META_DATA, MODE_ID_CHANGE, VIEW_MODE_CHANGE, CHANGE_EXPLORE_LOADING} from '../constants';
import {StoreState} from '../types';
import { ENABLE_FORCE_AUTH } from '../service/dataService';
const initial_state : StoreState = {
    dataset_id : 1, // null
    api_id : null, // null
    api_id_list : [1], // []
    datasetList: [],
    explore_refresh_number: 1,
    user_verify: !ENABLE_FORCE_AUTH,
    explore_loading: false,
    data: {},
    explore_meta_data: {},
    task_id : 2, // null
    mode_id: 2, // 1
    view_mode: 1 // 1
}
// 处理并返回 state 
export default (state = initial_state, action:any): StoreState => {
   
    switch (action.type) {
      case CHANGE_EXPLORE_LOADING:
        return {
          ...state,
          explore_loading: action.explore_loading
        }
      case VIEW_MODE_CHANGE:
        return {
          ...state,
          view_mode: action.view_mode
        }
      case MODE_ID_CHANGE:
        return {
          ...state,
          mode_id: action.mode_id
        }
      case DATASET_ID_CHANGE:
        // Change dataset id
        return {
          ...state,
          dataset_id: action.dataset_id,
        };
      case API_ID_CHANGE:
        // Change api id
        return {
          ...state,
          api_id: action.api_id,
        };
      case API_ID_LIST_CHANGE:
        // Change api id
        return {
          ...state,
          api_id_list: action.api_id_list,
        };
      case TASK_ID_CHANGE:
        // Change api id
        return {
          ...state,
          task_id: action.task_id,
        };
      case INIT_DATASET_LIST:
        // init dataset list
        return {
          ...state,
          datasetList: action.datasetList
        };
      case INIT_DATA:
        // init dataset list
        return {
          ...state,
          data: action.data
        };
      case INIT_EXPLORE_META_DATA:
        // init dataset list
        return {
          ...state,
          explore_meta_data: action.explore_meta_data,
          explore_refresh_number: state.explore_refresh_number + 1
        };
      case CLEAR_ID_INFO:
        return {
          ...state,
          dataset_id : null,
          api_id : null,
          api_id_list: [],
        }
      
      default:
        return state
    }
}


//import { DECREMENT, INCREMENT } from '../constants';

